var map = {
	"./bg 1.png": 320,
	"./iskut.png": 321,
	"./logo_notext.png": 322,
	"./painelusyvyys.png": 323,
	"./painelutaajuus.png": 324,
	"./pg-logo.png": 116,
	"./star.png": 325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 319
// module chunks = 0